import { render } from "./gaji-baru-pisah.vue?vue&type=template&id=03f8bdde"
import script from "./gaji-baru-pisah.vue?vue&type=script&lang=js"
export * from "./gaji-baru-pisah.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__